import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function BookPreview() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const pdfUrl = state?.pdfUrl;

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                background: "#111",
                color: "white",
            }}
        >
            {/* Header / Back Button */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    p: { xs: 1, sm: 2 },
                    background: "rgba(255,255,255,0.05)",
                }}
            >
                <IconButton
                    onClick={() => navigate(-1)}
                    sx={{
                        color: "white",
                        background: "rgba(255,255,255,0.1)",
                        "&:hover": { background: "rgba(255,255,255,0.2)" },
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Typography
                    variant="subtitle1"
                    sx={{ ml: 2, fontSize: { xs: "0.9rem", sm: "1rem" } }}
                >
                    Back to Books
                </Typography>
            </Box>

            {/* PDF Viewer */}
            <Box
                sx={{
                    flex: 1,
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        title="Book Preview"
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            borderRadius: "0px",
                        }}
                    ></iframe>
                ) : (
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontSize: { xs: "0.9rem", sm: "1rem" },
                        }}
                    >
                        No PDF file found.
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
